import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [...routes]
})

router.beforeEach((to, from, next) => {
	const token = Vue.$cookies.get('sbc_token');
	const userRole = Vue.$cookies.get('sbc_user_role');
	const currentUserRole = _checkRole(userRole);
	if (!token && to.name != 'login' && to.name != 'register') {
		next({ name: 'login' });
	} 
	else if(token && ( to.path =='/' || to.name == 'login')){
		if(currentUserRole == 'player') next('/cockfight');
		else if(currentUserRole == 'affiliate') next('/affiliate-dashboard');
	}
	else if( to.meta.requiresAuth ){
		console.log(include(to.meta.role, currentUserRole), to.meta.role, currentUserRole)
		if (!include(to.meta.role, currentUserRole)) {
			next('/PageNotFound');
			// if (to.path == '/' || to.path == '/login') {
			// 	if(currentUserRole == 'player') next('/cockfight');
			// 	else if(currentUserRole == 'affiliate') next('/affiliate-dashboard'); 
			// }
			// if(currentUserRole == 'player' &&  to.path  == '/affiliate-dashboard') next('/PageNotFound');
			// if(currentUserRole == 'affiliate' &&  to.path!= '/affiliate-dashboard') next('/affiliate-dashboard')
			// If roles do not match, redirect to appropriate route or deny access
			// You can redirect to a different page or just stay on the current page
			// For example, redirect to home page

		}else{
			// Continue to the requested route
			if (to.path == '/' || to.path == '/login') {
				if(currentUserRole == 'player') next('/');
				else if(currentUserRole == 'affiliate') next('/affiliate-dashboard'); 
			}else{
				next(); 
			}
		}
	}
	else {
		next();
	}
});
function _checkRole(userRole){
	if (  userRole == 'PLAYER-R' || userRole == 'PLAYER-VN' || userRole == 'PLAYER-D' ) return 'player';
	if (  userRole == 'AFFILIATE-D' || userRole == 'AFFILIATE-R' || userRole == 'AFFILIATE-VN') return 'affiliate';
	else return '';
}
function include(array, element) {
	return array.indexOf(element) !== -1;
  }


export default router
